import { render } from "./EditUsers.vue?vue&type=template&id=3321fea1"
import script from "./EditUsers.vue?vue&type=script&lang=js"
export * from "./EditUsers.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/greenified-mono-staging/ims.greenified.se/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__